var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c(_vm.tag,{ref:"text",tag:"component",staticClass:"animate-text",domProps:{"innerHTML":_vm._s(_vm.separatedWords)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }